import { SearchInput } from "components/ui/search-input";
import { Select } from "components/ui/select";
import React from "react";
import { TransferFilter, TransferStatusFilter } from "./transfer-filter";
import { transferStatusOptions } from "./transfer-status";

interface TransferFilterBarProps {
    filter: TransferFilter;
    onChange: (filter: TransferFilter) => void;
}

export const TransferFilterBar: React.FC<TransferFilterBarProps> = props => {
    const { filter, onChange } = props;
    return (
        <div className="max-w-2xl space-y-1 sm:space-y-2 md:flex md:items-center md:space-x-2 md:space-y-0">
            <div className="flex-1">
                <SearchInput
                    label="Search"
                    type="text"
                    value={filter.query}
                    onChange={e => onChange({ ...filter, query: e.target.value })}
                    placeholder="Client name"
                />
            </div>
            <div className="flex-1">
                <Select
                    label="Transfer Status"
                    value={filter.status}
                    onChange={e =>
                        onChange({
                            ...filter,
                            status: e.target.value as TransferStatusFilter,
                        })
                    }>
                    <option value="all">All statuses</option>
                    {transferStatusOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Select>
            </div>
        </div>
    );
};
